import { Button } from "antd";
import { Download, Plus, RefreshCw, Zap } from "lucide-react";
import { FC } from "react";
import { ImportServiceTicketModal } from "../../import-service-ticket-modal";
import { useBooking } from "~/store";
import { useRefreshBookingData } from "~/services/booking/booking.mutations";

interface BookingHeaderProps {}

export const BookingHeader: FC<BookingHeaderProps> = () => {
  const { openBookingModal } = useBooking();
  const refreshBookingData = useRefreshBookingData();

  return (
    <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4 mb-6">
      <div>
        <h1 className="text-2xl font-semibold">All Bookings</h1>
        <p className="text-gray-500">Manage and track all client bookings</p>
      </div>

      <div className="flex space-x-3">
        <Button
          icon={<RefreshCw size={16} />}
          onClick={refreshBookingData}
          className="flex items-center space-x-2"
          title="Refresh booking data"
        >
          Refresh
        </Button>
        <Button
          icon={<Download size={16} />}
          className="flex items-center space-x-2"
        >
          Export
        </Button>
        <Button
          icon={<Zap size={16} />}
          onClick={() => openBookingModal({ isEstimateMode: true })}
          className="flex items-center space-x-2 bg-green-50 border-green-500 text-green-700 hover:bg-green-100"
        >
          Quick Estimate
        </Button>
        <Button
          type="primary"
          icon={<Plus size={16} />}
          onClick={() => openBookingModal({})}
        >
          New Booking
        </Button>
        <ImportServiceTicketModal />
      </div>
    </div>
  );
};